export const PROJECT_ID = 'b17309a6-c1a6-4783-8b34-1e273f6881cc';
export const PREVIEW_API_KEY = process.env.REACT_APP_PREVIEW_API_KEY;

export const KENTICO_TYPES = {
  PRODUCT: 'product',
  THREE_COLUMN_GRID: 'n3_columns_grid',
  TWO_COLUMN_GRID: 'n2_columns_grid',
  HEADER: 'header',
  ACCORDION: 'accordion',
  ACCORDION_ITEM: 'accordion_item',
  ARTICLE_SLIDE: 'article_slide',
  ARTICLE_SLIDER: 'article_slider',
  DOWNLOAD_BAR: 'download_bar',
  BANNER: 'banner',
  CARD_SLIDER: 'card_slider',
  CARD_SLIDE: 'card_slide',
  IMAGE_SLIDER: 'image_slider',
  IMAGE_SLIDE: 'image_slide',
  SIMPLE_ACCORDION: 'simple_accordion',
  SIMPLE_ACCORDION_ITEM: 'simple_accordion_item',
  FILE_LINK: 'file_link',
  IMAGED_SECTION: 'imaged_section',
  NAVIGATOR: 'navigator',
  CONTACT_FORM: 'contact_form',
  CONTACT_FORM_SUPPORT: 'contact_form_support',
  HERO_IMAGE: 'hero_image',
  CALL_US: 'call_us',
  CONTACT_PERSON: 'contact_person',
  ContactLink: 'contact_link',
  HORIZONTALLY_NAVIGABLE_CONTENT: 'horizontally_navigable_content',
  CONTENT_WITH_HEADER: 'content_with_header',
  SEO: 'seo',
  SHARE_LINK: 'share_link',
  COLUMN: 'column',
  HTML_MODIFIER: 'html_modifier',
  TRANSLATIONS: 'translations',
  CORE: 'core',
  BLOG_ARTICLE: 'blog_article',
  BLOG_AUTHOR: 'blog_author',
  NEWSLETTER: 'newsletter',
  LINK_BANNER: 'link_banner',
  DIVIDED_BLOG_SECTION: 'divided_blog_section',
  BLOG_IMAGE_SLIDER: 'blog_image_slider',
  BLOG_IMAGE_SLIDE: 'blog_image_slide',
  LINK_TO_PRODUCT: 'link_to_product',
  PRODUCT_SLIDER: 'product_slider',
  PRODUCT_SLIDE: 'product_slide',
  CROPPED_ASSET: 'cropped_asset',
  CALCULATOR: 'calculator',
  CALCULATOR_VALUE: 'calculator_value',
  BLOG_CATEGORY_TRANSLATION: 'blog_category_translation',
  IMAGE_LINK: 'image_link',
  TITLE_AND_SUBTITLE: 'title_and_subtitle',
  FAQ_ACCORDION: 'faq_accordion',
  FAQ_ACCORDION_ITEM: 'faq_accordion_item',
  FOR_INVESTORS: 'forinvestors',
  FOR_INVESTORS_SECTION: 'for_investors_section',
  // FOR_INVESTORS_ITEM: 'for_investors_item',
  GLOBAL_META_TAGS: 'global_meta_tags',
  GLOBAL_META_TAG: 'global_meta_tag_element',
  NEWSLETTER_THANK_YOU_PAGE: 'newsletter_thank_you_page',
};

export const KENTICO_CONSTS = {
  MARKET_GOOGLE_PLAY_CODENAME: 'google_play',
  MARKET_APP_STORE_CODENAME: 'app_store',
};

export const KENTICO_HTML_MODIFIERS = {
  COLOR: 'color',
  MARGIN_TOP: 'margin-top',
  MARGIN_LEFT: 'margin-left',
  MARGIN_BOTTOM: 'margin-bottom',
  MARGIN_RIGHT: 'margin-right',
  BACKGROUND_COLOR: 'background-color',
  PADDING_TOP: 'padding-top',
  PADDING_LEFT: 'padding-left',
  PADDING_RIGHT: 'padding-right',
  PADDING_BOTTOM: 'padding-bottom',
};



// WEBPACK FOOTER //
// ./src/common/consts/kentico.js